module.exports = __webpack_public_path__ + "img/0756dfd5daa24abd7496faeabaad3027.png";